<template lang="pug">
v-container.pa-0(grid-list-lg)
  p.mb-3 目前貴院校使用的是#[b.primary--text {{ isECPay ? `樂台計畫金流服務` : `基本` }}]繳費方案，欲更改方案或了解更多，請#[router-link(:to='{ name: `support`}' ) 與我們聯絡]。

  v-layout(row wrap fill-height)
    v-flex(xs12 md6)
      PlanCard(:selected='!isECPay')
        template(#title) 基本
        template(#body)
          p 社團以傳統方式公佈繳費方式與定價，參賽者繳費後，經核對再手動至後台將表單設為已繳費。
          v-list(subheader)
            PlanListItem 手動修改繳費狀態
            PlanListItem(end) 參賽者需自行查詢繳費狀態

    v-flex(xs12 md6)
      PlanCard(fancy :selected='isECPay')
        template(#title)
          b.font-weight-bold 樂台計畫
          | 金流服務
        template(#body)
          p 參賽者報名後，自動產生一組虛擬匯款帳號供繳費。
          v-list(subheader)
            PlanListItem: .primary--text #[b 金流代收服務]
            PlanListItem: .primary--text 後台自動更新繳費狀態
            PlanListItem: .primary--text Line App 推播繳費成功通知
            PlanListItem: .primary--text 統一退費機制處理
            PlanListItem: div 減少人工核帳失誤
            PlanListItem: div 款項於報名截止後 3~5 個工作天匯入院校帳戶
            PlanListItem(end): div 單次報名產生 NT$15 手續費用
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import PlanCard from '@/components/config/PlanCard.vue'
import PlanListItem from '@/components/config/PlanListItem.vue'

export default defineComponent({
  components: {
    PlanCard,
    PlanListItem,
  },
})
</script>

<style scoped lang="sass">
</style>
